import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ModalButtonsComponent } from '../../modal/modal-buttons/modal-buttons.component';
import { ModalContentComponent } from '../../modal/modal-content/modal-content.component';
import { ModalToolbarComponent } from '../../modal/modal-toolbar/modal-toolbar.component';

@Component({
    selector: 'app-is-marketing-dialog',
    templateUrl: './is-marketing-dialog.component.html',
    styleUrls: ['./is-marketing-dialog.component.scss'],
    standalone: true,
    imports: [ModalContentComponent, ModalButtonsComponent, TranslateModule, ModalToolbarComponent, MatButtonModule],
})
export class IsMarketingDialogComponent {
    private readonly dialogRef = inject(MatDialogRef);

    onClose(value: boolean) {
        this.dialogRef.close(value);
    }
}
